import { Badge } from "@/components/ui/badge";
import type { CandidateStatus } from "@/services/adminModelCurrency";
import { statusLabel, statusVariant } from "./helpers";

const StatusBadge = ({ status }: { status: CandidateStatus }) => (
  <Badge variant={statusVariant(status)}>{statusLabel(status)}</Badge>
);

export default StatusBadge;
